// M20 — Piglins: bartering + aggro state table. PURE (ENG-1).
//
// Two pure cores for the nether's signature neutral mob:
//   • the aggro state table (`piglinHostile`) — MC's "gold-armour calm" rule;
//   • the barter currency + loot-table binding — a piglin trades a gold ingot for
//     a random nether trinket, rolled through the shared loot machinery
//     (data/loot/gameplay/piglin_bartering — the distribution lives in data).
// The actual roll is delegated to entities/loot.ts (rollLootByName); this file
// owns the rules that decide *when* a piglin fights and *what* it accepts.

/** The barter currency: a piglin admires and barters for a gold ingot. */
export const BARTER_CURRENCY = 'gold_ingot';

/** Loot table a completed barter rolls (data/loot/gameplay/piglin_bartering). */
export const BARTER_TABLE = 'gameplay/piglin_bartering';

/** Whether an item is what a piglin will barter for (a gold ingot). */
export function isBarterCurrency(item: string): boolean {
  return item === BARTER_CURRENCY;
}

/** Inputs to the piglin aggro decision (MC's neutral "gold-armour calm" mob). */
export interface PiglinView {
  /** The player wears at least one piece of gold armour. */
  readonly wearingGold: boolean;
  /** The player struck this piglin (or a piglin nearby) — arms the anger timer. */
  readonly provoked: boolean;
  /** The player mined gold ore or opened a bastion-guarded container nearby. */
  readonly goldTheft: boolean;
}

/** Piglin aggro state table. A piglin is neutral: passively hostile to a
 *  gold-less player but *calmed by wearing any gold armour* — yet ALWAYS
 *  provoked by an attack or by gold theft, gold armour or not. */
export function piglinHostile(v: PiglinView): boolean {
  if (v.provoked || v.goldTheft) return true; // theft/attack overrides the calm
  return !v.wearingGold;                        // else calmed only by gold armour
}
